const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClicks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.036,
    y: 2.036,
    width: 27.927,
    height: 27.927,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.724,25.1l-4.719-4.719,2.315-2.314A.819.819,0,0,0,27,16.708L13.115,12.08a.819.819,0,0,0-1.035,1.035L16.708,27a.819.819,0,0,0,1.355.32l2.314-2.315L25.1,29.724a.817.817,0,0,0,1.157,0l3.471-3.471A.817.817,0,0,0,29.724,25.1Zm-4.05,2.892L20.956,23.27a.817.817,0,0,0-1.157,0l-1.957,1.956L14.15,14.15l11.076,3.692L23.27,19.8a.818.818,0,0,0,0,1.157l4.718,4.718Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.673,8.582a.818.818,0,0,0,.818-.818V2.855a.818.818,0,1,0-1.636,0V7.764A.818.818,0,0,0,12.673,8.582Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.309,5.152A.818.818,0,0,0,5.152,6.309L8.623,9.78A.818.818,0,0,0,9.78,8.623Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.623,15.565,5.152,19.037a.818.818,0,0,0,1.157,1.157L9.78,16.723a.818.818,0,1,0-1.157-1.158Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.723,9.78l3.471-3.471a.818.818,0,0,0-1.157-1.157L15.565,8.623A.818.818,0,1,0,16.723,9.78Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.582,12.673a.818.818,0,0,0-.818-.818H2.855a.818.818,0,1,0,0,1.636H7.764A.818.818,0,0,0,8.582,12.673Z",
    style: {
      fill: "#f2b42a"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicks);
export default __webpack_public_path__ + "static/media/clicks.a19f05bae5e13bda460c09d868d87b75.svg";
export { ForwardRef as ReactComponent };